import React, { useState } from "react";

import HomeOutlined from "@mui/icons-material/HomeOutlined";
import AppsOutlined from "@mui/icons-material/AppsOutlined";
import AdminPanelSettingsOutlined from "@mui/icons-material/AdminPanelSettingsOutlined";

import ContactsOutlined from "@mui/icons-material/ContactsOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import FavoriteBorderOutlined from "@mui/icons-material/FavoriteBorderOutlined";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import InsightsOutlined from "@mui/icons-material/InsightsOutlined";
import MonitorHeartOutlined from "@mui/icons-material/MonitorHeartOutlined";

import GroupOutlined from "@mui/icons-material/GroupOutlined";
import ConfirmationNumberOutlined from "@mui/icons-material/ConfirmationNumberOutlined";
import EventOutlined from "@mui/icons-material/EventOutlined";
import AssignmentTurnedInOutlined from "@mui/icons-material/AssignmentTurnedInOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";

import WorkOutlineOutlined from "@mui/icons-material/WorkOutlineOutlined";
import PersonAddAltOutlined from "@mui/icons-material/PersonAddAltOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";

import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";

import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import Sidebar from "../pages/Sidebar";

const SecNavbar = () => {
  const [showsidebar, setShowsidebar] = useState(false);
  const Icon = ({ children }) => (
    <div
      className="d-flex justify-content-center align-items-center py-3"
      style={{ cursor: "pointer" }}
    >
      {children}
    </div>
  );

  return (
    <div
      onMouseEnter={() => setShowsidebar(true)}
      onMouseLeave={() => setShowsidebar(false)}
    >
      {showsidebar == true ? (
        <Sidebar />
      ) : (
        <div
          className="vh-100 border-end d-flex flex-column"
          style={{
            width: 70,
            opacity: showsidebar ? 0 : 1,
            transition: "opacity 0.2s ease",
            pointerEvents: showsidebar ? "none" : "auto",
          }}
        >
          {/* LOGO */}
          <div className="p-2 text-center">
            <img src="/assets/img/logo-small.svg" height="35" />
          </div>

          {/* SCROLL ICONS */}
          <div className="flex-grow-1 overflow-auto">
            {/* MAIN */}
            <Icon>
              <HomeOutlined fontSize="small" />
            </Icon>
            <Icon>
              <AppsOutlined fontSize="small" />
            </Icon>
            <Icon>
              <AdminPanelSettingsOutlined fontSize="small" />
            </Icon>

            {/* CRM */}
            <Icon>
              <ContactsOutlined fontSize="small" />
            </Icon>
            <Icon>
              <BusinessOutlined fontSize="small" />
            </Icon>
            <Icon>
              <FavoriteBorderOutlined fontSize="small" />
            </Icon>
            <Icon>
              <PersonOutlineOutlined fontSize="small" />
            </Icon>
            <Icon>
              <TimelineOutlined fontSize="small" />
            </Icon>
            <Icon>
              <InsightsOutlined fontSize="small" />
            </Icon>
            <Icon>
              <MonitorHeartOutlined fontSize="small" />
            </Icon>

            {/* HRM */}
            <Icon>
              <GroupOutlined fontSize="small" />
            </Icon>
            <Icon>
              <ConfirmationNumberOutlined fontSize="small" />
            </Icon>
            <Icon>
              <EventOutlined fontSize="small" />
            </Icon>
            <Icon>
              <AssignmentTurnedInOutlined fontSize="small" />
            </Icon>
            <Icon>
              <InsightsOutlined fontSize="small" />
            </Icon>
            <Icon>
              <SchoolOutlined fontSize="small" />
            </Icon>

            {/* RECRUITMENT */}
            <Icon>
              <WorkOutlineOutlined fontSize="small" />
            </Icon>
            <Icon>
              <PersonAddAltOutlined fontSize="small" />
            </Icon>
            <Icon>
              <DescriptionOutlined fontSize="small" />
            </Icon>

            {/* FINANCE */}
            <Icon>
              <AttachMoneyOutlined fontSize="small" />
            </Icon>
            <Icon>
              <AccountBalanceOutlined fontSize="small" />
            </Icon>

            {/* ADMIN */}
            <Icon>
              <Inventory2Outlined fontSize="small" />
            </Icon>
            <Icon>
              <SupportAgentOutlined fontSize="small" />
            </Icon>
            <Icon>
              <GroupOutlined fontSize="small" />
            </Icon>
            <Icon>
              <InsightsOutlined fontSize="small" />
            </Icon>
            <Icon>
              <SettingsOutlined fontSize="small" />
            </Icon>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecNavbar;
